import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import Box from '../../../../Global/Box'
import InputController from '../../../../Global/InputController'
import {
  GET_CAPACITY_TRUCKS,
  GET_STATUS_TRUCKS,
  GET_TRUCK_BY_ID,
  GET_TYPE_TRUCKS,
} from '../../../../../graphql/Catalog/Trucks/trucks'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { useHistory } from 'react-router-dom'
import { GET_USERS_BY_CHARGE } from '../../../../../graphql/Catalog/Users/user'

const FormTruck = ({ submitAction, truckId, modeModal }) => {
  const renameKeys = {
    plate_number: 'Placa',
    type: 'Tipo',
    capacity: 'Capacidad',
    status: 'Estado',
    user_id: 'Chofer',
  }

  const history = useHistory()
  const [optionsStatus, setOptionsStatus] = useState([])
  const [optionsType, setOptionsType] = useState([])
  const [optionsCapacity, setOptionsCapacity] = useState([])
  const [options, setOptions] = useState({
    user_id: [],
    status: [],
    type: [],
    capacity: [],
  })
  const [fieldsDisallowed, setFieldsDisallowed] = useState([])
  const [truckData, setTruckData] = useState({})

  const validationSchema = Yup.object().shape({
    plate_number: fieldsDisallowed.includes('plate_number')
      ? Yup.string()
      : Yup.string().required('La placa es requerida'),
    type: fieldsDisallowed.includes('type')
      ? Yup.string()
      : Yup.string().required('El tipo es requerido'),
    capacity: fieldsDisallowed.includes('capacity')
      ? Yup.string()
      : Yup.string().required('La capacidad es requerida'),
    status: fieldsDisallowed.includes('status')
      ? Yup.string()
      : Yup.string().required('El estado es requerido'),
    user_id: fieldsDisallowed.includes('user_id')
      ? Yup.string()
      : Yup.string().required('El chofer es requerido'),
  })

  const {
    methods,
    handleSubmit,
    control,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    loading: loadingTruck,
    error: errorTruck,
    data: dataTruck,
  } = useQuery(GET_TRUCK_BY_ID, {
    variables: {
      getTruckByIdId: +truckId,
    },
    fetchPolicy: 'no-cache',
    skip: !truckId,
  })

  const {
    loading: loadingStatus,
    error: errorStatus,
    data: dataStatus,
  } = useQuery(GET_STATUS_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingType,
    error: errorType,
    data: dataType,
  } = useQuery(GET_TYPE_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingCapacity,
    error: errorCapacity,
    data: dataCapacity,
  } = useQuery(GET_CAPACITY_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingUsers,
    error: errorUsers,
    data: dataUsers,
  } = useQuery(GET_USERS_BY_CHARGE, {
    variables: {
      edit: !!truckId,
      truck_id: +truckId,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (!truckId) return
      if (loadingTruck) return
      if (errorTruck) throw errorTruck
      if (!dataTruck) throw new Error('No se encontraron datos del camión')

      const { getTruckById } = dataTruck

      reset({
        plate_number: getTruckById.data.plate_number,
        type: getTruckById.data.type,
        status: getTruckById.data.status,
        capacity: getTruckById.data.capacity,
        user_id: getTruckById.data.user_id,
      })

      if (getTruckById.fieldsDisallowed.length > 0) {
        toastSweetAlert({
          mode: 'modalGeneric',
          icon: 'info',
          message: `${getTruckById.message}`,
        })

        setFieldsDisallowed(getTruckById.fieldsDisallowed)
        setTruckData(getTruckById.data)
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingTruck, errorTruck, dataTruck])

  useEffect(() => {
    try {
      if (loadingStatus) return
      if (errorStatus) throw errorStatus
      if (!dataStatus) throw new Error('No se encontraron datos de los estados')

      const { getStatusForTruck } = dataStatus

      setOptions((prev) => ({
        ...prev,
        status: getStatusForTruck,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: `${error.message}`,
      })
    }
  }, [loadingStatus, errorStatus, dataStatus])

  useEffect(() => {
    try {
      if (loadingType) return
      if (errorType) throw errorType
      if (!dataType) throw new Error('No se encontraron datos de los tipos')

      const { getTypesForTruck } = dataType

      setOptions((prev) => ({
        ...prev,
        type: getTypesForTruck,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingType, errorType, dataType])

  useEffect(() => {
    try {
      if (loadingCapacity) return
      if (errorCapacity) throw errorCapacity
      if (!dataCapacity)
        throw new Error('No se encontraron datos de las capacidades')

      const { getCapacityForTruck } = dataCapacity

      setOptions((prev) => ({
        ...prev,
        capacity: getCapacityForTruck,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingCapacity, errorCapacity, dataCapacity])

  useEffect(() => {
    try {
      if (loadingUsers) return
      if (errorUsers) throw errorUsers
      if (!dataUsers) return

      const { getUsersByCharge } = dataUsers

      const optionsUsers = getUsersByCharge.map((user) => {
        return {
          value: user.id,
          label: `${user.name} ${user.first_name}`,
        }
      })

      setOptions((prev) => ({
        ...prev,
        user_id: optionsUsers,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataUsers, errorUsers, loadingUsers])

  const getValue = (field) => {
    switch (field) {
      case 'user_id':
        return `${truckData.TrucksToUsersDrivers.name} ${truckData.TrucksToUsersDrivers.first_name}`
      case 'plate_number':
        return truckData.plate_number
      case 'type':
        return truckData.typeSpanish
      case 'capacity':
        return truckData.capacity + 'm³'
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitAction)}>
          <Box
            title={truckId ? 'Editar Camión' : 'Nuevo Camión'}
            btnSubmit
            btnSubmitText={truckId ? 'Actualizar' : 'Crear'}
            withCard={!modeModal}
            // btnRedPath={!modeModal ? history.push('/trucks') : () => {}}
            // btnRedPathTxt="Cerrar"
            content={
              <>
                {fieldsDisallowed.length > 0 && (
                  <div className="row p-3">
                    <div className="col-12 modal-status-box-header">
                      <div className="row">
                        {fieldsDisallowed.map((field) => (
                          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 p-2">
                            <span className="title-details">
                              {renameKeys[field]}
                            </span>
                            <br />
                            <span className="content-details">
                              {getValue(field)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  {!fieldsDisallowed.includes('user_id') && (
                    <>
                      <div className="col-lg-6">
                        <InputController
                          name="user_id"
                          label="Chofer"
                          control={control}
                          inputType="choosen"
                          options={options.user_id}
                          menuPosition="fixed"
                          placeholderTxt="Seleccione un chofer"
                          disabled={fieldsDisallowed.includes('user_id')}
                          infoText={
                            <>
                              <i class="fas fa-info-circle"></i>{' '}
                              {truckId
                                ? 'En el listado solo estarán los choferes que no esten asignados a ruta activa'
                                : 'En el listado estarán solos choferes que no esten asginados a camión'}
                            </>
                          }
                        />
                      </div>
                    </>
                  )}
                  {!fieldsDisallowed.includes('plate_number') && (
                    <div className="col-lg-6">
                      <InputController
                        name="plate_number"
                        label="Placa"
                        control={control}
                        inputType="text"
                        placeholderTxt="Ingrese la placa"
                        disabled={fieldsDisallowed.includes('plate_number')}
                      />
                    </div>
                  )}
                  {!fieldsDisallowed.includes('type') && (
                    <div className="col-lg-6">
                      <InputController
                        name="type"
                        label="Tipo"
                        control={control}
                        inputType="choosen"
                        options={options.type}
                        menuPosition="fixed"
                        placeholderTxt="Seleccione un tipo"
                        disabled={fieldsDisallowed.includes('type')}
                      />
                    </div>
                  )}
                  {!fieldsDisallowed.includes('capacity') && (
                    <div className="col-lg-6">
                      <InputController
                        name="capacity"
                        label="Capacidad"
                        control={control}
                        inputType="choosen"
                        options={options.capacity}
                        menuPosition="fixed"
                        placeholderTxt="Seleccione una capacidad"
                        disabled={fieldsDisallowed.includes('capacity')}
                      />
                    </div>
                  )}
                  {!fieldsDisallowed.includes('status') && (
                    <div className="col-lg-6">
                      <InputController
                        name="status"
                        label="Estado"
                        control={control}
                        inputType="choosen"
                        options={options.status}
                        menuPosition="fixed"
                        placeholderTxt="Seleccione un estado"
                        disabled={fieldsDisallowed.includes('status')}
                      />
                    </div>
                  )}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default FormTruck
